import './MaintenanceScreen.css'

import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Card } from 'primereact/card'

import { Footer } from './Footer'
import { Joubini } from './Joubini'

export const MaintenanceScreen: React.FC = () => {
  const { t } = useTranslation()
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const size = windowWidth < 768 ? 240 : 280

  return (
    <div className="maintenance-background w-screen min-h-screen flex flex-column maintenance-mode-container">
      <div className="flex-grow-1 flex flex-column justify-content-center align-items-center md:py-4">
        <div className="border-round-2xl mx-6 mt-6 md:mb-6 gradient-border">
          <Card className="maintenance-card px-3 pb-1 pt-3 md:px-6 md:pb-3 md:pt-6 text-center max-w-30rem border-round-2xl">
            <Joubini size={size} />

            <h1 className="text-100 text-xl md:text-3xl mt-4 mb-0 md:mt-6">
              {t('maintenance.title')}
            </h1>

            <p className="text-200 text-l md:text-xl line-height-3 mt-2">
              {t('maintenance.message')}
            </p>

            <p className="text-300 text-sm md:text-base line-height-3 mt-6">
              {t('maintenance.supportInfo')}{' '}
              <a
                href="mailto:joubini-solutions-de@nttdata.com"
                className="text-300 white-space-nowrap"
              >
                joubini-solutions-de@nttdata.com
              </a>
            </p>
          </Card>
        </div>
      </div>

      <div className="w-full flex md:justify-content-end justify-content-center px-5 py-4">
        <Footer />
      </div>
    </div>
  )
}
